'use client'

import { useEffect } from 'react'
import { initializeDatadogAnonymousUser } from '@/lib/analytics/datadogUser'

/** Sets Datadog RUM usr.id for guest sessions on first client render. */
export default function DatadogAnonymousUser() {
    useEffect(() => {
        initializeDatadogAnonymousUser()
    }, [])

    return null
}
